import {proxy} from '@infra/api/fetch/proxy';
import {DEFAULT_HEADERS} from '@infra/domain/model/_utils/defaultHeaders';
import {getAuthHeader} from '@infra/api/authManager/authManager';

export interface RequestData {
  readonly url: string;
  readonly method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  readonly body?: Record<string, unknown>;
}

const getHeaders = async (): Promise<HeadersInit> => {
  return {
    ...DEFAULT_HEADERS,
    ...(await getAuthHeader()),
  };
};

export const request = async <T>({url, method, body}: RequestData): Promise<T> => {
  const requestInit: RequestInit = {
    method: method || 'GET',
    headers: await getHeaders(),
    body: JSON.stringify(body),
  };
  const result = await fetch(proxy(url), requestInit);

  if (result.ok) {
    const response = await result.text();
    if (response.length) {
      return JSON.parse(response);
    }
    return Promise.resolve() as Promise<unknown> as Promise<T>;
  }
  return Promise.reject(new Error(`Request failed with status ${result.status}: ${result.statusText}`));
};
